'use client';

import { useCallback, useState } from 'react';
import { HStack, Stack } from '@terra/ui-styled-system';
import { Button, LegacyDialog } from '@terra/ui-design-system';

type ClearHistoryConfirmDialogProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => Promise<void> | void;
};

export function ClearHistoryConfirmDialog({
  isOpen,
  onOpenChange,
  onConfirm,
}: ClearHistoryConfirmDialogProps) {
  const [isClearing, setIsClearing] = useState(false);

  const handleConfirm = useCallback(async () => {
    setIsClearing(true);

    try {
      await onConfirm();
      onOpenChange(false);
    } finally {
      setIsClearing(false);
    }
  }, [onConfirm, onOpenChange]);

  return (
    <LegacyDialog.Root
      open={isOpen}
      onOpenChange={({ open }) => onOpenChange(open)}
    >
      <LegacyDialog.Backdrop />
      <LegacyDialog.Positioner>
        <LegacyDialog.Content maxW="sm" w="full">
          <Stack gap="4" p="5">
            <Stack gap="1">
              <LegacyDialog.Title>Clear HTTP history?</LegacyDialog.Title>
              <LegacyDialog.Description>
                This will permanently delete all entries in your HTTP History.
                This action cannot be undone.
              </LegacyDialog.Description>
            </Stack>

            <HStack gap="3" justifyContent="flex-end" width="full">
              <Button
                variant="outline"
                size="sm"
                onClick={() => onOpenChange(false)}
                disabled={isClearing}
              >
                Cancel
              </Button>
              <Button
                size="sm"
                colorPalette="red"
                onClick={() => void handleConfirm()}
                loading={isClearing}
              >
                Clear history
              </Button>
            </HStack>
          </Stack>
        </LegacyDialog.Content>
      </LegacyDialog.Positioner>
    </LegacyDialog.Root>
  );
}
